import React, { useState } from 'react';
import { EditIcon, UsersIcon, SendIcon, ArrowLeftIcon } from 'lucide-react';
import { useNavigate, useParams } from 'react-router-dom';
import { RightPanel } from '../components/RightPanel';
import { ReportForm } from '../components/ReportForm';
import { mockData } from '../utils/mockData';
interface TranscriptEditorProps {
  onOpenAffidavit: () => void;
}
export const TranscriptEditor = ({
  onOpenAffidavit
}: TranscriptEditorProps) => {
  const [isReportPanelOpen, setIsReportPanelOpen] = useState(false);
  const navigate = useNavigate();
  const {
    id
  } = useParams();
  const transcript = mockData.transcripts[id as keyof typeof mockData.transcripts] || [];
  const bodycamFootage = mockData.sidebar.bodycamFootage.find(item => item.id === id);
  const handleSubmitReport = () => {
    setIsReportPanelOpen(false);
    onOpenAffidavit();
  };
  return <>
      <main className="flex-grow p-6 overflow-auto" style={{
      backgroundImage: 'radial-gradient(circle at center, #2d4c6b 0%, #1f1f1f 100%)'
    }} data-id="element-248">
        <div className="max-w-[800px] mx-auto" data-id="element-249">
          <div className="mb-6 flex gap-3" data-id="element-250">
            <button className="px-4 py-2 bg-[#1a1a1a] border border-[#444444] rounded-lg text-sm font-medium flex items-center gap-2 hover:bg-[#2a2a2a]" data-id="element-251">
              <EditIcon size={16} data-id="element-252" />
              Edit Transcript
            </button>
            <button className="px-4 py-2 bg-[#1a1a1a] border border-[#444444] rounded-lg text-sm font-medium flex items-center gap-2 hover:bg-[#2a2a2a]" data-id="element-253">
              <UsersIcon size={16} data-id="element-254" />
              Speakers
            </button>
            <div className="flex-grow" data-id="element-255" />
            <button onClick={() => setIsReportPanelOpen(true)} className="px-4 py-2 bg-[#4a90e2] text-white rounded-lg text-sm font-medium flex items-center gap-2 hover:bg-[#3a7bc2]" data-id="element-256">
              <SendIcon size={16} data-id="element-257" />
              Transmit Report
            </button>
          </div>
          {bodycamFootage && <h1 className="text-xl font-semibold mb-6" data-id="element-258">
              {bodycamFootage.title}
            </h1>}
          <div className="bg-[#1a1a1a] border border-[#444444] rounded-lg p-6 space-y-4" data-id="element-259">
            {transcript.map(message => <p key={message.id} className="text-sm leading-relaxed" data-id="element-260">
                <strong data-id="element-261">
                  {message.speaker}
                  {message.badge && ` (${message.badge})`}:
                </strong>{' '}
                {message.content}
                <span className="block text-xs text-[#888888] mt-1" data-id="element-262">
                  {message.timestamp}
                </span>
              </p>)}
          </div>
        </div>
      </main>
      <RightPanel isOpen={isReportPanelOpen} onClose={() => setIsReportPanelOpen(false)} data-id="element-263">
        <ReportForm onClose={() => setIsReportPanelOpen(false)} onSubmit={handleSubmitReport} data-id="element-264" />
      </RightPanel>
    </>;
};